module.exports = __webpack_public_path__ + "static/img/diy-done.6fa6e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-done.png
// module id = YdQc
// module chunks = 0